export const SEARCH_GROUP_BY = {
    DAY: 'day',
}

// what the acriss level of an analyzer groups by. The chosen one is the mandatory filter:
// the axis cannot be built out of "everything".
export const ACRISS_GROUP_BY = {
	ACRISS_GROUP: 'acriss_group',
	ACRISS: 'acriss',
	CATEGORY: 'category',
}

export const ACRISS_GROUP_BY_OPTIONS = [
	{ label: 'Acriss Group', value: ACRISS_GROUP_BY.ACRISS_GROUP },
	{ label: 'Acriss', value: ACRISS_GROUP_BY.ACRISS },
	{ label: 'Category', value: ACRISS_GROUP_BY.CATEGORY },
]
